var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit-3",
    "data-name": "Icon feather-edit-3",
    transform: "translate(-4.25 -4.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12030",
    "data-name": "Path 12030",
    d: "M27.026,30.707H17.553a1.1,1.1,0,0,1,0-2.207h9.474a1.1,1.1,0,0,1,0,2.207Z",
    transform: "translate(-3.829 -6.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12031",
    "data-name": "Trac\\xE9 12031",
    d: "M18.711,5a2.161,2.161,0,0,1,3.158,0,2.422,2.422,0,0,1,0,3.311L8.711,22.111,4.5,23.214,5.553,18.8Z",
    transform: "translate(-0.25 -0.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.6eeafcd9b981d222476d8a971a6a8301.svg";
export { ForwardRef as ReactComponent };